import React, { useContext, useEffect } from "react";
import clsx from "clsx";
import "./CommonCheckbox.scss";
import Check from "./../../../../assets/images/Check.svg";
import { CheckboxContext } from "../../../../context/Checkbox/CheckboxContext";

const CommonCheckbox = ({
  name,
  children,
  disabled,
  id,
  value,
  onChange,
  checked,
}) => {
  const context = useContext(CheckboxContext);

  if (!context) {
    return (
      <div className={clsx("checkbox-container")}>
        <label htmlFor={id} className={clsx("checkbox-label")}>
          <input
            type="checkbox"
            id={id}
            disabled={disabled}
            checked={checked}
            name={name}
            onChange={({ target: { checked } }) => onChange(checked)}
            className={clsx("checkbox-input")}
          />
          <div className={clsx("checkbox", { "checkbox-checked": checked })}>
            <div className={clsx("checkbox-icon", { "icon-checked": checked })}>
              <Check width="14" height="14" fill={"#fff"} />
            </div>
          </div>
          <div className={clsx("checkbox")}></div>
          {children}
        </label>
      </div>
    );
  }

  const { isChecked, toggleValue } = context;

  return (
    <div className={clsx("checkbox-container")}>
      <label htmlFor={id} className={clsx("checkbox-label")}>
        <input
          type="checkbox"
          id={id}
          value={value}
          checked={isChecked(value)}
          name={name}
          onChange={({ target: { checked } }) => toggleValue({ checked, value })}
          className={clsx("checkbox-input")}
        />
        <div className={clsx("checkbox", { "checkbox-checked": isChecked(value) })}>
          <div className={clsx("checkbox-icon", { "icon-checked": isChecked(value) })}>
            {isChecked(value) && (
              <Check width="14" height="14" fill={"#fff"} />
            )}
          </div>
        </div>
        {children}
      </label>
    </div>
  );
};

export default CommonCheckbox;
